import * as Boots from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import * as apx from '../../api/apxService';
import { url } from '../general/generalUtil';
import { redirectToUrl } from '../../general/generalUtil';
import { Circle } from '../general/styled';

interface Props {
  user:any;
}

export function HeaderMenu(props:Props) {
  const handleLogout = async () => {
    await apx.post(apx.service.logout);
    redirectToUrl(`${url.pages}/login/?redirect=${encodeURIComponent(`${url.pages}/myreports/`)}`);
  };

  let firstCapital;
  let lastCapital;
  if (props.user) {
    firstCapital = props.user.first_name.charAt(0).toUpperCase();
    lastCapital = props.user.last_name.charAt(0).toUpperCase();
  }

  return (
    <div>
      <Boots.ButtonToolbar>
        <Boots.Dropdown id="dropdown-user-menu-1" pullRight={true}>
          <Boots.Dropdown.Toggle className="menuButton">
            <Circle>{ firstCapital }{ lastCapital }</Circle>
          </Boots.Dropdown.Toggle>
          <Boots.Dropdown.Menu className="menuItems">
            <Boots.MenuItem eventKey="1" onSelect={handleLogout}>
              <FormattedMessage id="logout" defaultMessage="Logout" /></Boots.MenuItem>
          </Boots.Dropdown.Menu>
        </Boots.Dropdown>
      </Boots.ButtonToolbar>
    </div>
  );
}
